import AuthRoute from './AuthRoute';
import Field from '@rezdy/components/Form/Field';
import React from 'react';
import TextInput from '@rezdy/components/Form/FormElements/TextInput';
import { withTranslation } from 'react-i18next';

class ConfirmSignIn extends AuthRoute {
    renderBody = () => {
        const { i18n } = this.props;
        return (
            <React.Fragment>
                <Field label={i18n.t('mfaToken')} name="mfaCode">
                    <TextInput type="text" />
                </Field>
            </React.Fragment>
        );
    };
}

export default withTranslation()(ConfirmSignIn);
